<p-splitButton 
styleClass="p-button-sm" 
[style]="splitButtonStyle" 
[label]="label" [icon]="icon" 
(onClick)="handleClick($event)" 
[disabled]="isSplitButtonDisabled"
[model]="items">
</p-splitButton>